import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
`;

export const Header = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors?.gray02};
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
`;

export const BackButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors?.text?.primary};
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.2s;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors?.gray01};
  }
`;

export const AvatarContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

export const AvatarPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors?.secondary};
  color: ${({ theme }) => theme.colors?.white01};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const HeaderInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ConversationName = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
  margin-bottom: 0.25rem;
`;

export const OnlineStatus = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs10};
  color: ${(props) => props.theme.colors?.success};
`;

export const OfflineStatus = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs10};
  color: ${(props) => props.theme.colors?.danger};
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const MessageWrapper = styled.div<{ isOwn: boolean }>`
  display: flex;
  justify-content: ${({ isOwn }) => (isOwn ? 'flex-end' : 'flex-start')};
`;

export const Message = styled.div<{ isOwn: boolean }>`
  max-width: 70%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background-color: ${({ isOwn, theme }) =>
    isOwn ? theme.colors?.secondary : theme.colors?.gray01};
  color: ${({ isOwn, theme }) => (isOwn ? theme.colors?.white01 : theme.colors?.text?.primary)};
  word-wrap: break-word;
`;

export const SenderName = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs10};
  font-weight: 600;
  margin-bottom: 0.25rem;
  opacity: 0.8;
`;

export const MessageContent = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  line-height: 1.4;
  margin-bottom: 0.25rem;
`;

export const MessageTime = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs08};
  opacity: 0.7;
  text-align: right;
`;

export const EmptyMessages = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const LoadingMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

export const LoadingText = styled.div`
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

export const InputContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors?.gray02};
`;

export const HeaderRight = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const MenuWrapper = styled.div`
  position: relative;
`;

export const MenuButton = styled.button`
  padding: 0.5rem;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  border-radius: 0.5rem;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors?.gray01};
  }
`;

export const Menu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: ${({ theme }) => theme.colors?.white01};
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  min-width: 200px;
  z-index: 10;
  overflow: hidden;
`;

export const MenuItem = styled.div<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  color: ${({ $danger, theme }) =>
    $danger ? theme.colors?.text?.danger : theme.colors?.text?.primary};

  &:hover {
    background-color: ${({ theme }) => theme.colors?.gray01};
  }
`;

export const MenuItemText = styled.span`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

